// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HwF0","type":"styles_type__38ciw","choices":"styles_choices__1p_R3"};